/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

export default function InputEditorWrapper(Component) {

	class InputEditorWrapper extends React.Component {
		constructor(props) {
			super(props);

			this.closeDeleteModal = this.closeDeleteModal.bind(this);
			this.deleteInput = this.deleteInput.bind(this);

		}

		closeDeleteModal() {

			this.props.closeAllModals();

		}

		deleteInput(e) {

			e.preventDefault();

			let confirmAction = () => {
					let constants = this.props.app.config.constants;

					if (this.props.input.id !== undefined) {
						if (this.props.user.detail.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
							this.props.deleteInput(this.props.input.id);
						} else {
							this.props.deleteRoute(this.props.router.params.routeId);
						}

					}
					this.props.closeAllModals();
				},
				deleteModal = (
					<DeleteModal
						modalCopy={"Are you sure you want to delete this feed?"}
						confirmAction={confirmAction}
						cancelAction={this.closeDeleteModal} />
				);

			this.props.addModal(deleteModal);

		}

		render() {
			return (
				<Component
					{...this.props}
					closeDeleteModal={this.closeDeleteModal}
					deleteInput={this.deleteInput}/>
			);
		}
	};

	InputEditorWrapper.propTypes = {
		input: PropTypes.object,
		changeHandler: PropTypes.func,
		textRuleHandler: PropTypes.func,
		scheduleHandler: PropTypes.func,
		deleteHandler: PropTypes.func,
		recordPath: PropTypes.func,
		statePath: PropTypes.string,
		initialActiveState: PropTypes.oneOfType([
			PropTypes.bool,
			PropTypes.number
		])
	};

	InputEditorWrapper.defaultProps = {
		input: {},
		changeHandler: null,
		textRuleHandler: null,
		scheduleHandler: null,
		deleteHandler: null,
		recordPath: null,
		statePath: 'input',
		initalActiveState: false
	};

	InputEditorWrapper.displayName = 'InputEditorWrapper';

	return ComponentWithContext(InputEditorWrapper);

};
